import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/location";
import { LocationService } from "../../services";

function* getLocation() {
  try {
    const data = yield call(() => LocationService.getUserLocation());
    if (!data) {
      yield put({ type: types.LOCATION_FAILED });
    } else {
      yield put({ type: types.LOCATION_SUCCEDDED, value: data });
    }
  } catch (e) {
    yield put({ type: types.LOCATION_FAILED })
  }
}

export default function* init() {
  yield takeEvery(
    types.LOCATION_REQUESTED,
    getLocation
  );
}
